import { Component, OnInit, ViewChild,ViewEncapsulation } from '@angular/core';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LoadService } from '../../services/load.service';
import { LocationService } from '../../services/location.service';
import { PackingEcService } from '../../services/packingec.service';
import { PalletsService } from '../../services/pallets.service';
import { TagsService } from '../../services/tags.service';
import { StockService } from '../../services/stock.service';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { listLocales } from 'ngx-bootstrap/chronos';
/*import { CreateNewAutocompleteGroup, SelectedAutocompleteItem, NgAutocompleteComponent } from "ng-auto-complete";*/

@Component({
selector: 'empaques',
templateUrl: './empaques.component.html',
styleUrls: ['./empaques.component.css'],
encapsulation: ViewEncapsulation.None
})
export class EmpaquesComponent implements OnInit {
  @ViewChild(ModalDirective) public lgModal: ModalDirective;
  //@ViewChild(NgAutocompleteComponent) public completer: NgAutocompleteComponent;
  public load:number;
  public isopen:boolean;
  public alert :string;
  public primeracarga:boolean;
  public tags: any[];
  public packings: any[];
  public idpacking:string;


  constructor(private _stockService:StockService,private _palletsService:PalletsService,private _tagsService:TagsService,private _packingecService:PackingEcService,private _locationService:LocationService,private _localeService: BsLocaleService,private _loaddata: LoadService) {
    this.isopen = false;
    this.alert = "";
    this.primeracarga = false;
    this.tags = [];
    this.packings = [];
    this.idpacking = '';
  }

  ngOnInit() {
    this.isopen = true;
    this.alert = "Iniciando carga general."
    this._loaddata.loadChange(10);
    this._localeService.use('es');
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.loadIncomePackings();
  }

  loadIncomePackings():void{
    this.alert = "Cargando packings."
    this.isopen = true;
    this._loaddata.loadChange(50);
    this._packingecService.getIncomePackings(0).subscribe(
      (response:any) => {
        for(let pac of response.data){
          if(pac.attributes.total_boxes > 0){
            this.packings.push(pac);
          }
        }
        this._loaddata.loadChange(90);
        this.loadData();
      },
      (error) => {
        this.showError((JSON.parse(error._body)).error);
      }
    );
  }

  /**
  * Carga el menu de movimientos
  */
  loadData():void{
    this.alert = "Carga Correcta."
    this.isopen = true;
    this._loaddata.loadChange(100);

    if(this.primeracarga === false){
      this.primeracarga = !this.primeracarga;
    }
  }

  /**
  * Carga todas las cajas relacionadas al packing.
  * @param packing 1 packing de Empaque -> Camara
  */
  onPackingSelected(packing):void{
    this.idpacking = packing.id;
    this.isopen = true;
    this.alert = "Cargando detalles del packing."
    this._loaddata.loadChange(50);
    this._tagsService.getTagsFromPacking(packing.id,4).subscribe((response:any) => {
      this.tags = response.data;
      this.isopen = true;
      this.alert = "Carga del packing "+this.idpacking+" completa."
      this._loaddata.loadChange(100);
    },
    (error) => {
      this.showError((JSON.parse(error._body)).error);
    });
  }

  backToSelectPacking(){
    this.tags = [];
    this.packings = [];
    this.idpacking = '';
    this.loadIncomePackings();
  }

  //Rechaza el packing
  onPackingResolve(resp){
    let idt = 0;
    this.alert = 'Generando peticion.';
    this.isopen = true;
    this._loaddata.loadChange(30);

    let prov = this._packingecService.transformData2(3,this.tags[0].relationships.packing.data.id);
    this._packingecService.update2(prov,this.tags[0].relationships.packing.data.id).subscribe(
      (response:any) => {
        this.alert = 'Recuperando QR.';
        for(let tag of this.tags){
          let prov= this._tagsService.transformData6(tag.id);
          this._tagsService.update2(tag.id,prov).subscribe(
            (response:any) =>{
              idt += 1;
              if(idt == this.tags.length){
                if(this.alert == 'Recuperando QR.' || this.alert == 'Generando peticion.'){
                  this.alert = "Rechazo exitoso. Etiquetas QR nuevamente disponibles."
                  this.backToSelectPacking();
                }
                else{
                  this.alert += " Rechazo incompleto. Existen problemas con etiquetas QR."
                }
                this._loaddata.loadChange(100);
              }
            },
            (error) => {
              //this.showError((JSON.parse(error._body)).error);
              this.alert += 'Error al eliminar etiqueta QR.'+tag.prefix+'-'+tag.sufijo;
              idt += 1;
              if(idt == this.tags.length){
                this.alert += " Rechazo incompleto. Existen problemas con etiquetas QR."
                this._loaddata.loadChange(100);
              }
            }
          );
        }
      },
      (error) => {
        this.showError((JSON.parse(error._body)).error);
      }
    );
  }

  /**
  * Cierra el modal
  */
  hideChildModal(): void {
    this.lgModal.hide();
  }

  /**
  * Cierra el mensaje de alerta.
  */
  onClosed(): void {
    this.isopen = false;
  }

  /**
  * Muestra un error
  * @param  msg mensaje del error
  */
  showError(msg:string){
    if(msg == undefined){
      this.alert = 'No tiene permisos para realizar la acción.';
    }
    else{
      this.alert = msg;
    }
    this._loaddata.loadChange(100);
    this.isopen =true;
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/empaques/empaques.component.ts